var React = require('react');

function OverdueInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"strokeLinecap":"square","strokeWidth":"2","fill":"none","stroke":"currentColor","strokeMiterlimit":"10"},[React.createElement("path",{"d":"M12 6v6h6M2.966 22.87l-.729-5.797 5.692 1.586","key":0}),React.createElement("path",{"d":"M2.237 17.073A11 11 0 101 12","strokeLinecap":"butt","key":1})]));
}

OverdueInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = OverdueInline;

OverdueInline.default = OverdueInline;
